import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import "../../../../CSS/AnalyticsBasedOnClientAndItem.css";
import ReactApexChart from "react-apexcharts";
import LoadingScreen from "../../../../Components/LoadingScreen";
import Loading2 from "../../../../Components/Loading2";
import Footer from "../../../../Components/Footer";
import { FaChartPie } from "react-icons/fa";
import { IoBarChartOutline } from "react-icons/io5";
import { BiScatterChart } from "react-icons/bi";
import { BsCalendar2Date } from "react-icons/bs";
import { FaChartArea } from "react-icons/fa";
const VehicleJobs = () => {
  const [isloading, setisloading] = useState(true);
  const [isLoading2, setLoading2] = useState(false);
  const [data, setData] = useState([]);
  const [fromdate, setFromdate] = useState(
    new Date(new Date().getFullYear(), 0, 2).toISOString()
  );
  const [todate, setTodate] = useState(new Date().toISOString());
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [analyticsData, setanalyticsData] = useState([]);
  // if (isloading) {
  //   return <LoadingScreen />;
  // }
  useEffect(() => {
    AnalyzeBasedOnClient();
  }, [fromdate, todate]);
  function isValidDate(dateString) {
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/; // Matches DD/MM/YYYY format

    if (!dateRegex.test(dateString)) {
      return false; // Format is invalid
    }

    const [day, month, year] = dateString.split("/").map(Number);

    // Year must be greater than 1900
    if (year < 1900) {
      return false;
    }

    // Month must be between 1 and 12
    if (month < 1 || month > 12) {
      return false;
    }

    // Validate day for the given month and year
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return false;
    }

    return true;
  }
  const AnalyzeBasedOnClient = () => {
    setLoading2(true);
    const stertDatePass =
      fromdate.slice(8, 10) +
      "/" +
      fromdate.slice(5, 7) +
      "/" +
      fromdate.slice(0, 4);
    const endDatePass =
      todate.slice(8, 10) + "/" + todate.slice(5, 7) + "/" + todate.slice(0, 4);
    console.log("stertDatePass", stertDatePass, "endDatePass", endDatePass);
    if (isValidDate(stertDatePass) && isValidDate(endDatePass)) {
      axios
        .post(
          `${BASEURL}/vehiclejobs`,
          {
            STARTDATE: stertDatePass,
            ENDDATE: endDatePass,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        )
        .then((response) => {
          setLoading2(false);
          setData(response.data);
          setanalyticsData(response.data);
          console.log(response.data);
        })
        .catch((error) => {
          setLoading2(false);
          console.log(error);
        });
    }
  };
  const [chartType, setChartType] = useState("bar");

  const handleButtonClick = (type) => {
    setChartType(type);
  };
  const [activeDates, setActiveDates] = useState(false);
  const handleDateFilterChange = (filter) => {
    const currentDate = new Date();
    let startDate = null;
    let endDate = null;
    setActiveDates(false);

    switch (filter) {
      case "last7days":
        startDate = new Date(
          currentDate.getTime() - 7 * 24 * 60 * 60 * 1000
        ).toISOString();
        endDate = currentDate.toISOString();
        break;
      case "last3days":
        startDate = new Date(
          currentDate.getTime() - 3 * 24 * 60 * 60 * 1000
        ).toISOString();
        endDate = currentDate.toISOString();
        break;
      case "last30days":
        startDate = new Date(
          currentDate.getTime() - 30 * 24 * 60 * 60 * 1000
        ).toISOString();
        endDate = currentDate.toISOString();
        break;
      case "lastMonth":
        startDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() - 1,
          2
        ).toISOString();
        endDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        ).toISOString();
        break;
      case "lastQuarter":
        startDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() - 3,
          2
        ).toISOString();
        endDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        ).toISOString();
        break;
      case "lastYear":
        const previousYear = currentDate.getFullYear() - 1;
        startDate = new Date(previousYear, 0, 2).toISOString(); // January 1st of the previous year
        endDate = new Date(previousYear, 12, 1).toISOString(); // December 31st of the previous year
        break;

      default:
        break;
    }

    setFromdate(startDate);
    setTodate(endDate);
  };

  const filterRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setActiveDates(false);
    }
  };
  return (
    <div ref={filterRef}>
      <div className="align__date_1">
        <div
          onClick={() => setActiveDates(!activeDates)}
          className="cursor-pointer flex items-center gap-2 "
        >
          <h2 className="text-2xl">
            {" "}
            <BsCalendar2Date />
          </h2>
          <span className="bg-white inline-block px-1 rounded border-1px border-solid">
            {fromdate.slice(8, 10) +
              "-" +
              fromdate.slice(5, 7) +
              "-" +
              fromdate.slice(0, 4)}
          </span>{" "}
          -{" "}
          <span className="bg-white inline-block px-1 rounded">
            {todate.slice(8, 10) +
              "-" +
              todate.slice(5, 7) +
              "-" +
              todate.slice(0, 4)}
          </span>
        </div>
        <div className="w-[200px]">
          {" "}
          {/* <Select options={options} onChange={handleDateFilterChange} /> */}
        </div>

        {activeDates && (
          <div className="date__custom">
            {/* Date filter buttons */}
            <div className="flex justify-between">
              <h1>Recommended</h1>
            </div>
            <button onClick={() => handleDateFilterChange("last3days")}>
              Last 3 Days
            </button>
            <button onClick={() => handleDateFilterChange("last7days")}>
              Last 7 Days
            </button>

            <button onClick={() => handleDateFilterChange("last30days")}>
              Last 30 Days
            </button>
            <h1>Calendar months</h1>
            <button onClick={() => handleDateFilterChange("lastMonth")}>
              Last Month
            </button>
            <button onClick={() => handleDateFilterChange("lastQuarter")}>
              Last Quarter
            </button>
            <button onClick={() => handleDateFilterChange("lastYear")}>
              Last Year
            </button>
            <h1>Custom date</h1>
            <main className="flex mx-1 gap-3">
              <div className="">
                <div>
                  <p>Start Date :</p>
                </div>
                <div>
                  <input
                    value={fromdate.split("T")[0]}
                    type="date"
                    onClick={() => setActiveDates(true)}
                    onChange={(e) => {
                      setFromdate(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="">
                <div>
                  <p>End Date :</p>
                </div>
                <div>
                  <input
                    value={todate.split("T")[0]}
                    type="date"
                    onClick={() => setActiveDates(true)}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        alert("Please select a valid todate");
                      } else {
                        setTodate(e.target.value);
                      }
                    }}
                  />
                </div>
              </div>
            </main>
          </div>
        )}
      </div>
      <section className="flex mt-5 flex-wrap gap-3 justify-center lg:justify-between flex-col-reverse lg:flex-row">
        {analyticsData.length > 0 && (
          <div className="overflow-y-auto max-h-[400px] px-4  lg:w-[25%] overflow-x-hidden ">
            <table className="custom-table text-sm overflow__y__ relative w-full ">
              <thead
                className="header-cell sticky top-[0px] left-[10px] text-[10px]"
                style={{ zIndex: 20 }}
              >
                <tr>
                  <td className="">MONTH&nbsp;END </td>
                  <td className="text-right">JOB CARD COUNTER</td>
                  <td className="text-right">COST EXPENSES</td>
                </tr>
              </thead>
              <tbody>
                {analyticsData.length > 0 &&
                  analyticsData.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        textTransform: "uppercase",
                      }}
                      className="text-[10px]"
                    >
                      {" "}
                      <td className=" ">
                        {item.MONTHEND
                          ? moment(item?.MONTHEND).format(" MMM YYYY")
                          : "0"}
                      </td>
                      <td className="text-right">
                        {item["JOBCARDCOUNTER"]
                          ? item["JOBCARDCOUNTER"].toLocaleString()
                          : "0"}
                      </td>
                      <td className="text-right">
                        {item["TOTALCOSTONWORKSHOPEXPENSES"]
                          ? item["TOTALCOSTONWORKSHOPEXPENSES"].toLocaleString()
                          : "0"}
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr className="font-bold text-[10px]">
                  <td className="text-left">TOTAL</td>

                  <td className="text-right">
                    {analyticsData
                      .reduce(
                        (sum, item) => sum + (item["JOBCARDCOUNTER"] || 0),
                        0
                      )
                      .toLocaleString()}
                  </td>
                  <td className="text-right">
                    {analyticsData
                      .reduce(
                        (sum, item) =>
                          sum + (item["TOTALCOSTONWORKSHOPEXPENSES"] || 0),
                        0
                      )
                      .toLocaleString()}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
        <div
          style={{ margin: "0 auto" }}
          onClick={() => setActiveDates(false)}
          className="lg:w-[70%] w-full"
        >
          {isLoading2 ? (
            <Loading2 />
          ) : (
            <>
              {analyticsData.length > 0 ? (
                <div>
                  <div className="chart__active__buttons">
                    <button
                      className={
                        chartType === "bar"
                          ? "active__chart"
                          : "not__active__chart"
                      }
                      onClick={() => handleButtonClick("bar")}
                    >
                      <IoBarChartOutline />
                    </button>
                    <button
                      className={
                        chartType === "pie"
                          ? "active__chart"
                          : "not__active__chart"
                      }
                      onClick={() => handleButtonClick("pie")}
                    >
                      <FaChartPie />
                    </button>

                    <button
                      className={
                        chartType === "scatter"
                          ? "active__chart"
                          : "not__active__chart"
                      }
                      onClick={() => handleButtonClick("scatter")}
                    >
                      <BiScatterChart />
                    </button>
                    <button
                      className={
                        chartType === "area"
                          ? "active__chart "
                          : "not__active__chart  "
                      }
                      onClick={() => handleButtonClick("area")}
                    >
                      <FaChartArea />
                    </button>
                  </div>
                  {chartType === "bar" && (
                    <ReactApexChart
                      options={{
                        chart: {
                          id: "bar-chart", // Change the ID for the bar chart
                        },
                        xaxis: {
                          categories: analyticsData.map((item) =>
                            moment(item?.MONTHEND).format(" MMM YYYY")
                          ),
                          title: {
                            text: "Months", // X-axis label
                          },
                        },
                        yaxis: [
                          {
                            title: {
                              text: "JOB CARD COUNTER", // Y-axis label
                            },
                          },
                          {
                            opposite: true,
                            title: {
                              text: "WORKSHOP EXPENSES",
                            },
                          },
                        ],
                        dataLabels: {
                          enabled: false, // Disable the data labels for bar chart
                        },
                        annotations: {
                          yaxis: [
                            {
                              yaxisIndex: 1,
                              label: {
                                text: "TOTAL COST ON WORKSHOP EXPENSES",
                                style: {
                                  color: "#008FFB",
                                },
                              },
                            },
                          ],
                        },
                        tooltip: {
                          y: {
                            formatter: (value) =>
                              Number(value).toLocaleString(),
                          },
                        },
                      }}
                      series={[
                        {
                          name: "JOB CARD COUNTER",
                          data: analyticsData.map(
                            (item) => item?.JOBCARDCOUNTER
                          ),
                        },
                        {
                          name: "TOTAL COST ON WORKSHOP EXPENSES",
                          data: analyticsData.map(
                            (item) => item?.TOTALCOSTONWORKSHOPEXPENSES
                          ),
                        },
                      ]}
                      type="bar" // Change chart type to "bar"
                      height={300}
                    />
                  )}
                  {chartType === "area" && (
                    <ReactApexChart
                      options={{
                        chart: {
                          id: "area-chart", // Change the ID for the area chart
                        },
                        xaxis: {
                          categories: data.map((item) =>
                            moment(item?.MONTHEND).format(" MMM YYYY")
                          ),
                          title: {
                            text: "MONTHEND", // X-axis label
                          },
                        },
                        yaxis: [
                          {
                            title: {
                              text: "AMOUNT", // Y-axis label
                            },
                          },
                        ],
                        dataLabels: {
                          enabled: false, // Disable the data labels for area chart
                        },
                      }}
                      series={[
                        {
                          name: "JOB CARD COUNTER",
                          data: data.map((item) => item?.JOBCARDCOUNTER),
                        },
                        {
                          name: "TOTAL COST ON WORKSHOP EXPENSES",
                          data: data.map(
                            (item) => item?.TOTALCOSTONWORKSHOPEXPENSES
                          ),
                        },
                      ]}
                      type="area" // Change chart type to "area"
                      height={300}
                    />
                  )}
                  {chartType === "pie" && (
                    <div className="flex__pai">
                      <aside className="for__single__pai">
                        <ReactApexChart
                          options={{
                            labels: analyticsData.map((item) =>
                              moment(item?.MONTHEND).format(" MMM YYYY")
                            ),
                            title: {
                              text: "JOB CARD COUNTER", // Y-axis label
                            },
                            dataLabels: {
                              enabled: true, // Enable data labels for pie chart
                            },
                            tooltip: {
                              enabled: true,
                              y: {
                                formatter: function (val, opts) {
                                  let index = opts.dataPointIndex;
                                  let name = "BREAKDOWN COUNTER";
                                  return name + ": " + val;
                                },
                              },
                            },
                          }}
                          series={analyticsData.map(
                            (item) => item?.JOBCARDCOUNTER
                          )}
                          type="pie" // Set chart type to "pie"
                          height={300}
                        />
                      </aside>
                      <aside className="for__single__pai">
                        <ReactApexChart
                          options={{
                            labels: analyticsData.map((item) =>
                              moment(item?.MONTHEND).format(" MMM YYYY")
                            ),
                            title: {
                              text: "TOTAL COST ON WORKSHOP EXPENSES",
                            },
                            dataLabels: {
                              enabled: true, // Enable data labels for pie chart
                            },
                            tooltip: {
                              enabled: true,
                              y: {
                                formatter: function (val, opts) {
                                  let index = opts.dataPointIndex;
                                  let name = "TOTAL COST ON BREAKDOWN";
                                  return name + ": " + val;
                                },
                              },
                            },
                          }}
                          series={analyticsData.map(
                            (item) => item?.TOTALCOSTONWORKSHOPEXPENSES
                          )}
                          type="pie" // Set chart type to "pie"
                          height={300}
                        />
                      </aside>
                    </div>
                  )}

                  {chartType === "scatter" && (
                    <ReactApexChart
                      options={{
                        chart: {
                          id: "scatter-chart", // Change the ID for the scatter chart
                        },
                        xaxis: {
                          type: "datetime",
                          categories: analyticsData.map((item) =>
                            new Date(item?.MONTHEND).getTime()
                          ), // Convert to milliseconds
                          title: {
                            text: "Months", // X-axis label
                          },
                        },
                        yaxis: [
                          {
                            title: {
                              text: "JOB CARD COUNTER", // Y-axis label
                            },
                          },
                          {
                            opposite: true,
                            title: {
                              text: "WORKSHOP EXPENSES",
                            },
                          },
                        ],
                        title: {
                          text: "Scatter Chart",
                        },
                      }}
                      series={[
                        {
                          name: "JOB CARD COUNTER",
                          data: analyticsData.map((item) => ({
                            x: new Date(item?.MONTHEND).getTime(), // Convert to milliseconds
                            y: item?.JOBCARDCOUNTER,
                          })),
                        },
                        {
                          name: "TOTAL COST ON WORKSHOP EXPENSES",
                          data: analyticsData.map((item) => ({
                            x: new Date(item?.MONTHEND).getTime(), // Convert to milliseconds
                            y: item?.TOTALCOSTONWORKSHOPEXPENSES,
                          })),
                          yAxis: 1, // Assign this series to the right y-axis
                        },
                      ]}
                      type="scatter" // Set chart type to "scatter"
                      height={300}
                    />
                  )}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "20px",
                    marginTop: "50px",
                    textDecoration: "underline",
                  }}
                >
                  NO DATA AVAILABLE
                </div>
              )}
            </>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default VehicleJobs;
